<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="rows"
      class="elevation-1 ma-0 tableCust"
      :footer-props="{
        'items-per-page-text': $t('dataTable.rowsPerPageText'),
        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
      }"
      :no-data-text="$t('dataTable.noDataText')"
      :headerProps="{
        'sort-by-text': $t('dataTable.sortByText')
      }"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-dialog v-model="dialog" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                dark
                class="mb-2 primary"
                v-on="on"
                @click="newItem"
                :disabled="seriesSelected ? false : true"
              >
                <v-icon left dark>fa-plus</v-icon>
                {{ $t("common.form.add") }}
              </v-btn>
              &nbsp; &nbsp;
              <v-btn
                color="primary"
                dark
                class="mb-2 primary"
                v-on="on"
                @click="importItem"
                :disabled="seriesSelected ? false : true"
              >
                <v-icon left dark>far fa-file-import</v-icon>
                {{ $tc("common.form.import") }}
              </v-btn>
            </template>
            <v-card class="borderDialog">
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-form
                  ref="formSR"
                  class="pt-4 inputSeries"
                  v-on:submit.prevent="pressEnter"
                >
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-if="editorType == 'new' || editorType == 'edit'"
                        v-model="inputName"
                        ref="inputName"
                        :label="$t('common.form.name')"
                        required
                        outlined
                        dense
                        :rules="[
                          (v) => $inputRules({value: v, minSize: 1, maxSize: 40}, 'fieldLength') || $t('page.series.name-required')
                        ]"
                      ></v-text-field>

                      <!-- IMPORT -->
                      <v-radio-group
                        v-if="editorType == 'import'"
                        v-model="importSeriesClassGroupsFrom"
                        mandatory
                        row
                      >
                        <v-radio
                          :label="$t('page.series.seriesRadioLbl')"
                          @change="getSeries"
                          value="series"
                        ></v-radio>
                        <v-radio
                          :label="$t('page.series.eventsRadioLbl')"
                          @change="getEvents"
                          value="events"
                        ></v-radio>
                        <v-radio
                          :label="$t('page.series.organizationRadioLbl')"
                          @change="getOrganizations"
                          value="organization"
                        ></v-radio>
                      </v-radio-group>
                      <v-autocomplete
                        v-if="
                          editorType == 'import' &&
                          importSeriesClassGroupsFrom == 'series'
                        "
                        v-model="seriesModel"
                        :items="seriesItems"
                        ref="selectSeriesInput"
                        small-chips
                        deletable-chips
                        outlined
                        dense
                        required
                        :rules="[
                          (v) => !!v || $t('page.series.series-required'),
                        ]"
                        @keyup.enter="importClassGroups"
                        :no-data-text="$t('common.no_data')"
                      ></v-autocomplete>
                      <v-autocomplete
                        v-if="
                          editorType == 'import' &&
                          importSeriesClassGroupsFrom == 'events'
                        "
                        v-model="eventsModel"
                        :items="eventsItems"
                        ref="selectEventsInput"
                        chips
                        deletable-chips
                        small-chips
                        outlined
                        dense
                        required
                        :rules="[
                          (v) => !!v || $t('page.series.events-required'),
                        ]"
                        @keyup.enter="importClassGroups"
                        :no-data-text="$t('common.no_data')"
                      ></v-autocomplete>
                      <v-autocomplete
                        v-if="
                          editorType == 'import' &&
                          importSeriesClassGroupsFrom == 'organization'
                        "
                        v-model="organizationModel"
                        :items="organizationItems"
                        ref="selectOrganizationInput"
                        chips
                        deletable-chips
                        small-chips
                        outlined
                        dense
                        required
                        :rules="[
                          (v) => !!v || $t('page.series.organization-required'),
                        ]"
                        @keyup.enter="importClassGroups"
                        :no-data-text="$t('common.no_data')"
                      ></v-autocomplete>
                      <!-- /IMPORT -->
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" small text @click="close">{{
                  $t("common.form.cancel")
                }}</v-btn>
                <v-btn
                  v-if="editorType == 'new'"
                  color="blue darken-1"
                  small
                  text
                  @click="create"
                  >{{ $t("common.form.create") }}</v-btn
                >
                <v-btn
                  v-if="editorType == 'edit'"
                  color="blue darken-1"
                  small
                  text
                  @click="save"
                  >{{ $t("common.form.update") }}</v-btn
                >
                <v-btn
                  v-if="editorType == 'import'"
                  color="blue darken-1"
                  small
                  text
                  @click="importClassGroups"
                  >{{ $t("common.form.import") }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small @click="confirmDelete(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
    <SGSNotificationConfirm
      v-if="dialogNotification"
      :notificationMessage="$t('common.confirm-delete')"
      @cancel="dialogNotification = false"
      @agree="deleteItem"
      type="warning"
      :acept="$t('common.form.delete')"
      :reject="$t('common.form.cancel')"
    />
    <SGSNotificationAlert v-if="dialogAlert" :notificationMessage="alertMessage" @cancel="closeAlert" type='error'/>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState } from "vuex";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";

export default {
  mixins: [apiCalls],
  components: {
    SGSNotificationConfirm, SGSNotificationAlert
  },
  data() {
    return {
      dialogNotification: false,
      inputName: "",
      dialog: false,
      rows: [],
      item: {
        id: "",
        name: 0,
      },
      editorType: "new",
      importSeriesClassGroupsFrom: "series",
      seriesModel: null,
      eventsModel: null,
      organizationModel: null,
      seriesItems: [],
      eventsItems: [],
      organizationItems: [],
      dialogAlert: false,
      alertMessage: '',
      reopenEdition: false,
      indexDialog: 'dialog'
    };
  },
  computed: {
    ...mapState({
      seriesSelected: (state) => state.series.seriesSelected
    }),
    formTitle() {
      let title = "";

      switch (this.editorType) {
        case "new":
          title = this.$t("page.series.add-group");
          break;

        case "import":
          title = this.$t("page.series.import-groups");
          break;

        default:
          title = this.$t("page.series.edit-group");
      }

      return title;
    },
    loading: {
        get(){
          return this.$store.state.loading;
        },
        set(val){
          this.$store.commit('TOGGLE_OVERLAY', val);
        }
    },
    headers() {
      return [
        {
          text: this.$t("common.table.name"),
          value: "name",
        },
        {
          text: this.$t("common.table.actions"),
          value: "actions",
          sortable: false,
        },
      ];
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    seriesSelected() {
      this.getRecords();
    },
  },
  methods: {
    init()
    {
      this.getRecords();
    },
    pressEnter() {
      if (this.editorType == "edit") {
        this.save();
      } else {
        this.create();
      }
    },
    async getRecords() {
      if (this.seriesSelected) {
        const response = await this.api(
          "get",
          `/api/v1/promoter/series/group/${this.seriesSelected.id}`
        );

        this.rows = [];
        if(response.success === 1)
        {
          response.message.data.forEach((element) => {
            const row = {
              id: element.id,
              name: element.groupName,
              actions: "actions",
            };
            this.rows.push(row);
          });
        }
      }
    },
    newItem() {
      this.inputName = "";
      if (this.$refs.formSR) this.$refs.formSR.reset();
      this.editorType = "new";
    },

    importItem() {
      if (this.$refs.formSC) this.$refs.formSC.resetValidation();
      switch (this.importSeriesClassGroupsFrom) {
        case "series":
          this.getSeries();
          break;

        case "events":
          this.getEvents();
          break;

        case "organization":
          this.getOrganizations();
          break;
      }
      this.editorType = "import";
      this.dialog = true;
    },

    editItem(item) {
      this.editorType = "edit";
      this.dialog = true;
      this.inputName = item.name;
      this.item.id = item.id;
    },

    confirmDelete(item) {
      this.dialogNotification = true;
      this.item = item;
    },

    async deleteItem() {
      let data = {
        id: this.item.id,
      };

      const response = await this.api(
        "DELETE",
        `/api/v1/promoter/series/group/${this.item.id}`,
        data
      );

      if(response && response.success && !response.error){
        this.getRecords();
        this.close();
      } else {
        if(!response) {
          this.dialogAlert =  true;
          this.alertMessage = this.$t('page.series.error_general');
        } else if (response && (response.error || response.message)) {
          if(Array.isArray(response.error)) {
            this.dialogAlert =  true;
            this.alertMessage = this.$t('page.series.'+response.error[0], { field: this.$t('page.series.group') });
          } else if(typeof response.error == 'string') {
            this.dialogAlert =  true;
            this.alertMessage = this.$t('page.series.'+response.error, { field: this.$t('page.series.group') });
          } else if(response.message) {
            this.alertMessage = this.$t('page.series.error_general');
            if(Array.isArray(response.message) && response.message.length > 0) {
              this.alertMessage = this.$t('page.series.'+response.message[0], { field: this.$t('page.series.group') });
            } else if(typeof response.message == 'string') {
              this.alertMessage = this.$t('page.series.'+response.message, { field: this.$t('page.series.group') });
            }
            this.dialogAlert =  true;
          } else {
            this.dialogAlert =  true;
            this.alertMessage = this.$t('page.series.error_general');
            }
        }
      }
    },

    close() {
      this.dialog = false;
      this.dialogNotification = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeAlert(){
      this.dialogAlert=false;
      if(this.reopenEdition){
        this.dialog = true;
      }
    },
    async create() {
      if (!this.$refs.formSR.validate()) {
        if (this.inputName == "") {
          this.$refs.inputName.focus();
          return;
        }
        return;
      }

      let data = {
        seriesId: this.seriesSelected.id,
        groupName: this.inputName,
      };

      const response = await this.api(
        "POST",
        "/api/v1/promoter/series/group",
        data
      );

      if(response && response.success && !response.error){
        this.getRecords();
        this.close();
        this.reopenEdition = false;
      } else {
        if(!response) {
          this.dialog = false;
          this.dialogAlert =  true;
          this.alertMessage = this.$t('page.series.error_general');
          this.reopenEdition = true;
        } else if (response && (response.error || response.message)) {
          if(Array.isArray(response.error)) {
            this.dialog = false;
            this.dialogAlert =  true;
            this.alertMessage = this.$t('page.series.'+response.error[0], { field: this.$t('page.series.series_group') });
            this.reopenEdition = true;
          } else if(typeof response.error == 'string') {
            this.dialog = false;
            this.dialogAlert =  true;
            this.alertMessage = this.$t('page.series.'+response.error, { field: this.$t('page.series.series_group') });
            this.reopenEdition = true;
          } else if(response.message) {
            this.alertMessage = this.$t('page.series.error_general');
            if(Array.isArray(response.message) && response.message.length > 0) {
              this.alertMessage = this.$t('page.series.'+response.message[0], { field: this.$t('page.series.series_group') });
            } else if(typeof response.message == 'string') {
              this.alertMessage = this.$t('page.series.'+response.message, { field: this.$t('page.series.series_group') });
            }
            this.dialog = false;
            this.dialogAlert =  true;
            this.reopenEdition = true;
          } else {
            this.dialog = false;
            this.dialogAlert =  true;
            this.alertMessage = this.$t('page.series.error_general');
            this.reopenEdition = true;
            }
        }
      }
    },

    async importClassGroups() {
      const importType = this.importSeriesClassGroupsFrom;

      if (!this.$refs.formSR.validate()) {
        if (
          this.seriesModel == null ||
          (this.seriesModel == "" && importType == "series")
        ) {
          this.$refs.selectSeriesInput.focus();
          return false;
        } else if (
          this.eventsModel == null ||
          (this.eventsModel == "" && importType == "events")
        ) {
          this.$refs.selectEventsInput.focus();
          return false;
        } else if (
          this.seriesModel == null ||
          (this.seriesModel == "" && importType == "organization")
        ) {
          this.$refs.selectOrganizationInput.focus();
          return false;
        }
        return;
      }

      this.dialog = false;
      const method = 'POST';
      let link = '/wrong-link-generation';
      let data = {
        /** current Serie */
        seriesId: this.seriesSelected.id
      }

      switch (importType){
        case 'series':
          link = '/api/v1/promoter/series/class-groups/import-from/series';
          data.targetSeriesId = this.seriesModel;
          break;

        case 'events':
          link = '/api/v1/promoter/series/class-groups/import-from/event';
          data.targetEventsId = this.eventsModel;
          break;

        case 'organization':
          link = '/api/v1/promoter/series/class-groups/import-from/organization';
          data.targetOrganizationId = this.organizationModel;
          break;
      }

      const response = await this.api(
        method,
        link,
        data
      );

      if(!response || !response.success){ 
          this.alertMessage = this.$t('page.series.error_general');
          if(response && Array.isArray(response.error) && response.error.length > 0) {
              this.alertMessage = this.$t('common.request.'+response.error[0]);
          } else if(response && typeof response.error == 'string') {
              this.alertMessage = this.$t('common.request.'+response.error)
          } else if(response && Array.isArray(response.message) && response.message.length > 0) {
              this.alertMessage = this.$t('common.request.'+response.message[0]);
          } else if(response && typeof response.message == 'string') {
              this.alertMessage = this.$t('common.request.'+response.message)
          }
          this.dialog = false;
          this.dialogAlert = true;
          this.reopenEdition = true;
          return; 
      }

      this.getRecords();
      this.close();
    
    },
    async getSeries() {
      if (this.seriesSelected) {
        this.loading = true;
        const response = await this.getApi("/api/v1/promoter/series");

        response.sort(function(a, b) {
          return b.id - a.id;
        })

        if (response != undefined) {
          for (var i = 0; i < response.length; i++) {
            if (response[i].id == this.seriesSelected.id) {
              continue;
            }
            this.seriesItems.push({
              text: response[i].seriesName,
              value: response[i].id,
            });
          }
          this.allSeries = response;
          this.loading = false;
        } else {
          this.loading = false;
        }
      }
    },
    async getEvents() {
      if (this.seriesSelected) {
        this.loading = true;
        const response = await this.getApi(
          "/api/v1/promoter/series/class/import/events"
        );

        response.message.sort(function(a, b) {
          return new Date(b.eventCreated) - new Date(a.eventCreated);
        });

        if (response != undefined) {
          for (var i = 0; i < response.message.length; i++) {
            this.eventsItems.push({
              text: response.message[i].eventName,
              value: response.message[i].id,
            });
          }
          this.loading = false;
        } else {
          this.loading = false;
        }
      }
    },
    async getOrganizations() {
      if (this.seriesSelected) {
        this.loading = true;
        const response = await this.getApi(
          "/api/v1/promoter/series/class/import/organizations"
        );

        if (response != undefined) {
          for (var i = 0; i < response.message.length; i++) {
            this.organizationItems.push({
              text: response.message[i].name,
              value: response.message[i].id,
            });
          }
          this.loading = false;
        } else {
          this.loading = false;
        }
      }
    },

    async save() {
      if (!this.$refs.formSR.validate()) {
        if (this.inputName == "") {
          this.$refs.inputName.focus();
          return;
        }
        return;
      }

      let data = {
        id: this.item.id,
        groupName: this.inputName,
      };

      const response = await this.api(
        "PUT",
        "/api/v1/promoter/series/group",
        data
      );

      if(response && response.success && !response.error){
        this.getRecords();
        this.close();
        this.reopenEdition = false;
      } else {
        if(!response) {
          this.dialog = false;
          this.dialogAlert =  true;
          this.alertMessage = this.$t('page.series.error_general');
          this.reopenEdition = true;
        } else if (response && (response.error || response.message)) {
          if(Array.isArray(response.error)) {
            this.dialog = false;
            this.dialogAlert =  true;
            this.alertMessage = this.$t('page.series.'+response.error[0], { field: this.$t('page.series.series_group_id') });
            this.reopenEdition = true;
          } else if(typeof response.error == 'string') {
            this.dialog = false;
            this.dialogAlert =  true;
            this.alertMessage = this.$t('page.series.'+response.error, { field: this.$t('page.series.series_group_id') });
            this.reopenEdition = true;
          } else if(response.message) {
            this.alertMessage = this.$t('page.series.error_general');
            if(Array.isArray(response.message) && response.message.length > 0) {
              this.alertMessage = this.$t('page.series.'+response.message[0], { field: this.$t('page.series.series_group_id') });
            } else if(typeof response.message == 'string') {
              this.alertMessage = this.$t('page.series.'+response.message, { field: this.$t('page.series.series_group_id') });
            }
            this.dialog = false;
            this.dialogAlert =  true;
            this.reopenEdition = true;
          } else {
            this.dialog = false;
            this.dialogAlert =  true;
            this.alertMessage = this.$t('page.series.error_general');
            this.reopenEdition = true;
            }
        }
      }
    },
  },
};
</script>

<style scoped>
.v-application .headline {
  font-size: 24px !important;
}
.v-dialog > .v-card > .v-card__text {
  padding: 0 40px 20px;
}
.v-card__actions .v-btn {
  background-color: var(--v-primary-darken2) !important;
  color: white !important;
}
.v-toolbar__content > button {
  margin: 5px;
}
</style>
